export default __webpack_public_path__ + "static/media/success.035d5e4e.svg";